<template>
  <div class="video-cards-container">
    <!--<h2 class="title">-->
    <!--<span>{{ namedCategory }}</span>-->
    <!--</h2>-->
    <div class="mb-4">
      <div role="group" aria-label="Basic example" class="btn-group mt-4" v-show="hasCategories && componentStyle.mode=='default'">
        <button
          type="button"
          class="btn btn-lg"
          :class="currentCategory === 'trends' ? 'btn-primary' : 'btn-outline-secondary'"
          @click="setCategory('trends')"
        >
          {{ $t('categories.trends') }}
        </button>
        <button
          type="button"
          class="btn btn-lg"
          :class="currentCategory === 'popular' ? 'btn-primary' : 'btn-outline-secondary'"
          @click="setCategory('popular')"
        >
          {{ $t('categories.popular') }}
        </button>
        <button
          type="button"
          class="btn btn-lg"
          :class="currentCategory === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
          @click="setCategory('all')"
        >
          {{ $t('categories.all') }}
        </button>
      </div>
    </div>
    <div v-if="hasCategories  && componentStyle.mode=='demo'  && videos.length !== 0">
      <nav class="slidemenu">

        <!-- Item 1 -->
        <input type="radio" name="slideItem" id="slide-item-1" class="slide-toggle" :checked="currentCategory =='all'"/>
        <label for="slide-item-1"  @click="setCategory('all')" ><span>{{ $t('categories.all') }}</span></label>

        <!-- Item 2 -->
        <input type="radio" name="slideItem" id="slide-item-2" :checked="currentCategory =='trends'" class="slide-toggle"/>
        <label for="slide-item-2"  @click="setCategory('trends')"><span>{{ $t('categories.trends') }}</span></label>

        <!-- Item 3 -->
        <input type="radio" name="slideItem" id="slide-item-3" :checked="currentCategory =='popular'" class="slide-toggle"/>
        <label for="slide-item-3"  @click="setCategory('popular')"><span>{{ $t('categories.popular') }}</span></label>


        <div class="clear"></div>

        <!-- Bar -->
        <div class="slider">
          <div class="bar"></div>
        </div>

      </nav>

      <nav class="slideMenuMobile">
        <b-dropdown
          class="dropdown-Category"
        >
          <div slot="button-content" class="dropdown-image">
            <span class="dropdown-text Category-current">{{ $t('categories.'+currentCategory) }}</span>
          </div>
          <b-dropdown-item

            key="all"
            :value="'all'"
            @click="setCategory('all')"
          >
            <span class="dropdown-text">{{$t('categories.all') }}</span>
          </b-dropdown-item>
          <b-dropdown-item

            key="trends"
            :value="'trends'"
            @click="setCategory('trends')"
          >
            <span class="dropdown-text">{{$t('categories.trends') }}</span>
          </b-dropdown-item>
          <b-dropdown-item

            key="popular"
            :value="'popular'"
            @click="setCategory('popular')"
          >
            <span class="dropdown-text">{{$t('categories.popular') }}</span>
          </b-dropdown-item>
        </b-dropdown>

      </nav>

    </div>


    <div class="cards-wrapper">
      <h3 class="rubrique-title" v-if="relatedVideos.length > 0 && hasCarousel">
        {{ $t('titles.suggestions') }}
      </h3>
      <div v-if="hasCarousel">
        <carousel
          navigation-prev-label="<i class='fo-icon-arrow-left'></i>"
          navigation-next-label="<i class='fo-icon-arrow-right'></i>"
          :loop="true"
          :mouse-drag="false"
          :navigation-enabled="true"
          :pagination-enabled="false"
          @pageChange="pageRelatedChanged"
          :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
        >
          <slide v-for="(video, index) in relatedVideos" :key="index">
            <video-vignette
              :video="video"
              :hide="['date']"
              card-type="default"
              @selected="selectVideo"
            ></video-vignette>
          </slide>
        </carousel>
      </div>
      <div v-if="(isSideNav || !hasCategories) && componentStyle.mode=='default'">
        <h3 class="mt-0 rubrique-title">
          {{ $t('categories.' + currentCategory) }}
        </h3>
      </div>
      <div v-if="hasCarousel && showCarousel">
        <carousel
          navigation-prev-label="<i class='fo-icon-arrow-left'></i>"
          navigation-next-label="<i class='fo-icon-arrow-right'></i>"
          :loop="true"
          :mouse-drag="false"
          :navigation-enabled="true"
          :pagination-enabled="false"
          @pageChange="pageChanged"
          :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
        >
          <slide v-for="(video, index) in alaUneVideos" :key="index">
            <video-vignette
              :video="video"
              card-type="default"
              :hide="['date']"
              @selected="selectVideo"
            ></video-vignette>
          </slide>
        </carousel>
      </div>
      <div class="video-list" v-if="!hasCarousel">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-6" v-for="video in videos"  v-if="componentStyle.mode=='default'">
            <video-vignette
              :class="[{'custom-icon':componentStyle.customIcon}]"
              :video="video"
              :hide="['date']"
              @selected="selectVideo"
              v-scroll-to="{ el: '#video-wrapper', offset: -200 }"
            ></video-vignette>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6" v-for="video in videos" v-if="componentStyle.mode=='demo'">
            <video-vignette
              :cardType="componentStyle.mode"
              :video="video"
              @selected="selectVideo"
              v-scroll-to="{ el: '#video-wrapper', offset: -200 }"
            ></video-vignette>
          </div>
        </div>
        <infinite-loading @infinite="loadMoreVideos" :distance="10" v-show="!(currentCategory === 'home' && currentPage > 1)">
          <div slot="spinner">
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-6">
                <card-loader></card-loader>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 d-none d-sm-block">
                <card-loader></card-loader>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 d-none d-md-block">
                <card-loader></card-loader>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 d-none d-xl-block">
                <card-loader></card-loader>
              </div>
            </div>
          </div>
          <div slot="no-more"></div>
          <div slot="no-results" v-show="videos.length === 0 && componentStyle.mode=='default'"> {{ $t('labels.no_video') }} </div>
          <div slot="no-results" v-show="videos.length === 0  && componentStyle.mode=='demo'" class="div-no-vid" >  <div> <i class="icon-demo-no_video demo-no_video"></i>  </div> <div class="text-demo-no_video">{{ $t('labels.no_video') }} </div> </div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

import VideoVignette from '~/node_modules/video-vignette/src/components/Component.vue';
import CardLoader from './common/CardLoader';
import { categories } from '~/static/constants.js';
import { Carousel, Slide } from 'vue-carousel';

import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';

export default {
  name: 'VideoCards',
  components: {
    InfiniteLoading,
    VideoVignette,
    CardLoader,
    Carousel,
    Slide,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  data() {
    return {
      showCarousel:true,
      infiniteState: null,
      categories,
    };
  },
  watch: {
    isLoading(isLoading) {
      if (this.currentPage === 2 && !isLoading && this.videos.length > 0) {
        this.selectVideo(this.videos[0]);
      }
      if (this.infiniteState) {
        if (this.isEndReached) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
          if (this.currentPage === 2 && this.keyword) {
            this.$scrollTo('.video-list', 500, { offset: -220 });
          }
        }
      }
    },
    videos(videos) {
      if (videos.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
         // this.loadMoreVideos();
        }
        this.infiniteState.reset();
      }
    },
    alauneVideos(videos) {
      if (videos.length === 0) {
        if (!this.isLoading) {
          //this.loadMoreVideos();
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      videos: 'videos/getAllVideos',
      alauneVideos: 'videos/getAllVideos',
      isLoading: 'videos/getLoading',
      isEndReached: 'videos/getEndReached',
      currentCategory: 'videos/getCurrentCategory',
      currentPage: 'videos/getCurrentPage',
      keyword: 'videos/getKeyword',
      isFullWidth: 'layout/isFullWidth',
      currentSecondaryColor: 'layout/getCurrentSecondaryColor',
      currentPrimaryColor: 'layout/getCurrentPrimaryColor',
      isSideNav: 'layout/isSideNav',
      hasCarousel: 'layout/hasCarousel',
      hasCategories: 'layout/hasCategories',
      hasScroll: 'layout/hasScroll',
      relatedVideos: 'videos/getRelatedVideos',
      getCurrentSkin: 'layout/getCurrentSkin',
      getNavigation: 'layout/getNavigation',
      componentStyle: 'layout/getComponentStyle',

    }),
  },
  methods: {
    ...mapActions('videos', [
      'paginateVideos',
      'setCurrentVideo',
      'getVideoMediaById',
      'setCurrentCategory',
      'fetchRelated',
    ]),
    setCategory(category) {
      this.setCurrentCategory(category);
      this.$router.push({ name: 'home', params: { category } });
    },
    async loadMoreVideos($state) {
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
      if (this.isEndReached && this.infiniteState) {
        this.infiniteState.complete();
        return;
      }
      console.log("loadMoreVideos")
      await  this.paginateVideos();
    },
    selectVideo(video) {
      this.showCarousel=true;

      this.$Progress.start();
      this.setCurrentVideo(video);
      this.getVideoMediaById(video.id);

    },
    pageChanged(page) {

      let length;
      length = this.videos.length;
      if (!this.isEndReached && page * 8 >= length - 4) {
        this.paginateVideos();
      } else {
        return;
      }
    },
    pageRelatedChanged(page) {

      let length;
      length = this.relatedVideos.length;
      if (!this.isEndReached && page * 8 >= length - 4) {
        this.fetchRelated();

      } else {
        return;
      }
    },
  },
  created() {
    console.log("created video card")
    //this.paginateVideos();
    if (this.hasCarousel) {
      this.fetchRelated();
    }
    eventHub.$on('showCarousel', () => {
      console.log("showCarousel false")
      this.showCarousel=false
    });
  },
  mounted() {},
};
</script>

<style lang="scss">
@import '../assets/scss/_variables.scss';
@import "../assets/scss/mix.scss";
.video-cards-container {
  padding: 0 calc(1rem - 15px);
  h2.title {
    text-align: left;
    margin-top: 1em;
    font-size: 1.5em;
    @include hasColorTitre(var(--color-title));
    margin-bottom: 1em;
    span {
      border-bottom: 2px solid var(--secondary-color);
    }
  }
  .btn-group {
    .btn {
      font-size: 1rem;
      &:hover {
        color: #ffffff;
      }
    }
  }
}

.img-wrapper:after {
  content: '';
  position: absolute;
  width: 101%;
  height: 40%;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.1), #00000000);
}




.card-wrapper {
  .card-title {
    @include hasColorTitre(var(--color-title));

  }
}
@media (min-width: 992px) {
  .video-cards-container {
    padding: 0 calc(2rem - 15px);
  }
}

.btn-primary {
  color: #fff;
  background-color: var(--secondary-color) !important;
  border-color: var(--secondary-color) !important;
  box-shadow: none !important;
}

.btn-outline-secondary {
  border-color: var(--secondary-color) !important;
  color: var(--secondary-color) !important;
  box-shadow: none !important;
  &:hover {
    background-color: var(--secondary-color) !important;
    color: #fff !important;
  }
}

/*
   * IE support
   */

.card-wrapper {
  .card {
    .card-title {
      height: 1.2em;
    }
    .card-text {
      margin-bottom: 0.5rem;
      font-size: 0.8em;
      color: #555;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -o-text-overflow: ellipsis;
      line-height: 1.2em;
      height: 2.4em;
    }
    margin-bottom: 30px;
    .tag-info {
      font-size: 0.8em;
    }
  }
}
.VueCarousel {
  padding: 0 0.5em;
  border-radius: 0.15rem;
  margin-top: 1em;
  .VueCarousel-wrapper {
    .VueCarousel-slide {
      padding: 1em 0.5em;
    }
  }
  .VueCarousel-navigation {
    .VueCarousel-navigation-button {
      display: block;
      width: 3em;
      height: 3em;
      background-size: contain;
      background: white no-repeat center;
      border-radius: 1.5em;
      background-size: 1.5em;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
      outline: none !important;
      color: var(--primary-color) !important;
      &.VueCarousel-navigation-prev {
        // background-image: url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==');
        left: 2.5em;
      }
      &.VueCarousel-navigation-next {
        // background-image: url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=');
        right: 2.5em;
      }
    }
  }
}
.rubrique-title {
  @include hasColorTitre(var(--color-title));
  font-size: 1.4em;
  margin: 1.5em 0 0.5em;
  font-weight: 400;
}
.card-wrapper .card .card-text {
  word-break: break-word;
}


.slidemenu{
  font-family: arial, sans-serif;
  margin: 1.5em 0;
  overflow: hidden;
  .clear{
    clear: both;
  }

  .slide-toggle{
    display: none;
  }



  label{
    width: 20%;
    text-align: center;
    display: block;
    float: left;
    color:  #484848;;
    opacity: 0.5;
    font-size: 20px;
    margin-bottom: 0!important;
  }

  label:hover{
    cursor: pointer;
    color: #666;
  }

  label span{
    display: block;
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    font-family: Roboto;
  }



  /*Bar Style*/

  .slider{
    width: 100%;
    height: 5px;
    display: block;
    background: #e8e8e8;
    margin-top: 10px;
    opacity: 1;
  }

  .slider .bar{
    width: 20%;
    height: 5px;
    background: var(--secondary-color);
    border-radius: 5px;
    opacity: 1;
  }

  /*Animations*/
   label, .slider .bar {
    transition: all 500ms ease-in-out;
    -webkit-transition: all 500ms ease-in-out;
    -moz-transition: all 500ms ease-in-out;
  }

  /*Toggle*/

  .slide-toggle:checked + label{
    opacity: 1;
  }



   #slide-item-1:checked ~ .slider .bar{ margin-left: 0; }
  #slide-item-2:checked ~ .slider .bar{ margin-left: 20%; }
  #slide-item-3:checked ~ .slider .bar{ margin-left: 40%; }



}

.darkMode{

  /deep/   .tag-info ,.icon-demo-calendar {
    color: white!important;
  }

  .card-title , .slidemenu label ,  .Category-current , .dropdown-Category .dropdown-toggle , .dropdown-Category .dropdown-toggle:hover{
    color: white!important;
  }
  .slideMenuMobile .dropdown-menu{
    background-color: #313131;
  }
  .dropdown-item{
    color:black!important;
  }
  .dropdown-item:hover{
    color: black!important;
  }


}
.demo-no_video{
  color:#a1a1a1;
  font-size: 5em;
}
.div-no-vid{
margin-top: 10%;
}
.text-demo-no_video{
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  padding-top: 1em;
  color:#a1a1a1;

}
@media screen and(max-width: 991px){

  .slidemenu label{
    font-size: 15px!important;
  }

}
@media screen and(max-width: 991px){

  .slidemenu label{
    font-size: 15px!important;
    width: 33%;
  }


  #slide-item-1:checked ~ .slider .bar{ margin-left: 0; }
  #slide-item-2:checked ~ .slider .bar{ margin-left: 33%!important; }
  #slide-item-3:checked ~ .slider .bar{ margin-left: 66%!important; }
  .slider .bar{
    width: 33%!important;}
}


@media screen and(min-width: 467px) {
.slideMenuMobile{
  display: none;
}
}
@media screen and(max-width: 467px) {
.slidemenu{
  display: none;
}
}



.dropdown-menu{
  background-color: white;
}
.dropdown-Category{
  width: 100%;
  z-index: 999;
  margin-bottom: 2em;
  .btn-secondary{
    background-color: transparent!important;
    border-color: transparent!important;
    color: #484848 !important;
    align-items: center!important;
    border-bottom:2px solid #c5c6c7!important;

  }
  .btn-secondary:hover{
    color: #484848 !important;

  }

  transform: translateY(10px);
  .dropdown-toggle,
  .dropdown-toggle:hover,
  .dropdown-toggle.show,
  .dropdown-toggle.active,
  .dropdown-toggle:active {
    background: none !important;
    color: #484848 !important;
    align-items: center!important;
    border-bottom:2px solid #c5c6c7!important;
    display: flex;
    flex-direction: row;
    box-shadow: none !important;
  }
  .image_Lang {
    width: 20px;
  }
  .dropdown-image {
    margin-top: -10px;
    width: 100%;
    justify-content: start;
    display: flex;
  }

  .dropdown-text {
    width: 100%;
    justify-content: start;
    display: flex;
    &.Category-current {
      margin-right: 7px;
    }
  }

  .dropdown-menu {
    min-width: 1rem;
  }
}



.custom-icon{
  .tag-info {
    .icon{
      &.duration {
        background-image:
          url('data:image/svg+xml;base64,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') !important;
      }
      &.nb-views {
        background-image:
          url('data:image/svg+xml;base64,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')!important;    }
    }
  }
}




</style>



// WEBPACK FOOTER //
// src/components/VideoCards.vue